import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { userInfoSelector, hasGlobalAccessSelector } from '../selectors/auth-selectors';

export class InitPendoScript extends Component{
    componentDidMount(){
        if( window.initializePendo ){
            const {
                isSuperuser,
                userInfo: {
                    accountType,
                    customerFullRealmName,
                    customerId,
                    licenseType,
                    loggedInCustomerId,
                    realm,
                    pps,
                    userCenterId
                }
            } = this.props;

            const pendoVistorInfo = {
                id: userCenterId,
                role: isSuperuser ? 'superuser' : 'customer',
                visitor_product: 'EFD NextGen'
            };

            const pendoAccountInfo = {
                account_name: isSuperuser ? 'Proofpoint' : customerFullRealmName,
                account_type: accountType ? accountType : '', // TODO: How do we get this info into Metis?
                customerId: loggedInCustomerId ? loggedInCustomerId : customerId,
                id: realm,
                license_type: licenseType ? licenseType : '', //TODO: How do we get this info into Metis??
                pps: pps ? pps : '', //TODO: How do we get this info into Metis?
                product: 'EFD NextGen',
            };

            const pendoIdentityInfo = { account: pendoAccountInfo, visitor: pendoVistorInfo };

            window.initializePendo( pendoIdentityInfo );
        }
    }

    render(){
        return '';
    }
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        isSuperuser: hasGlobalAccessSelector( state ),
        userInfo: userInfoSelector( state ),
    };
};

InitPendoScript.propTypes = {
    isSuperuser: PropTypes.bool,
    userInfo: PropTypes.shape( {
        accountType: PropTypes.string,
        customerFullRealmName: PropTypes.string,
        customerId: PropTypes.string,
        licenseType: PropTypes.string,
        loggedInCustomerId: PropTypes.string,
        pps: PropTypes.string,
        realm: PropTypes.oneOfType( [
            PropTypes.string,
            PropTypes.number] ),
        userCenterId: PropTypes.string,
    } )
};


export default connect( mapStateToProps, {} )( InitPendoScript );
